import { GridElementDc, LayerMapElementDc, LayerTemplateModelDc, ScaleBarElementDc } from "@evergis/api";
import { DEFAULT_LAYER_OPACITY } from "../project/createProjectContent";
import { getLegendPlacement } from "../../../ducks/print/getLegendPlacement";
import { PrintTemplateType, PrintType } from "../../../interfaces/print";
import { createLegendLayers } from "./createLegendLayers";
import { pixelsToMms } from "./pixelsToMms";
import { PrintTemplate } from "./PrintTemplate";
import { templateConfig } from "./templateConfig";

export class MapTemplate extends PrintTemplate<LayerTemplateModelDc> {
  static TYPE = PrintTemplateType.Map;

  public async serialize(): Promise<LayerTemplateModelDc> {
    const { settings, title, layers, defaultScaleRange } = this.printInfo;
    const legendEnabled = getLegendPlacement(settings) === PrintType.MapWithLegend;

    return {
      type: MapTemplate.TYPE,
      map: this.getMapElement(),
      legendEnabled,
      legendLayers: legendEnabled ? await createLegendLayers(layers, defaultScaleRange) : undefined,
      title,
      ...this.getPrintFormatInfo(),
    };
  }

  protected resolveTemplateConfig() {
    const { settings } = this.printInfo;
    const { legend } = settings;

    if (!legend || legend.placement === PrintType.MapAndLegend) {
      return templateConfig.Map;
    }

    return super.resolveTemplateConfig();
  }

  private getGridElement(): GridElementDc {
    const { settings } = this.printInfo;
    const { grid } = settings;

    if (!grid) return;

    return {
      color: grid.color.toString("hex"),
      gridThickness: grid.size,
      enabled: true,
    };
  }

  private getScaleBarElement(): ScaleBarElementDc {
    const { settings } = this.printInfo;

    if (settings.withScale) {
      return {
        enabled: true,
        width: 100,
        thickness: 1,
        height: 16,
        fontSize: 14,
      };
    }
  }

  private getMapElement(): LayerMapElementDc {
    const { layers, baseMapName, srid, mapCenter, resolution, rectangle } = this.printInfo;

    return {
      layers: [
        { layerServiceName: baseMapName, layerOpacity: DEFAULT_LAYER_OPACITY },
        ...layers.map(this.createLayerModel).reverse(),
      ],
      mapCenter,
      spatialReference: srid,
      paperWidth: pixelsToMms(rectangle.width),
      paperHeight: pixelsToMms(rectangle.height),
      resolution,
      enabled: true,
      scaleBar: this.getScaleBarElement(),
      gridElement: this.getGridElement(),
    };
  }
}
